import { BoxContainer } from "../Common/BoxContainer";
import { GridFragment } from "../Common/GridFragment";
import { AttributeContainer } from "./AttributeContainer";
import { AttributeGroup } from "./AttributeGroup";
import { ConfigurationBackdrop } from "./ConfigurationBackdrop";
import { ConfigurationComponentType } from "./ConfigurationComponentType";
import { ConfigurationContainer } from "./ConfigurationContainer";
import { ConfigurationDescription } from "./ConfigurationDescription";
import { ConfigurationHeadline } from "./ConfigurationHeadline";
import { ConfigurationInfoText } from "./ConfigurationInfoText";
import { ConfigurationNavigation } from "./ConfigurationNavigation";
import { ConfigurationPropertyText } from "./ConfigurationPropertyText";
import { ConfigurationStatusFab } from "./ConfigurationStatusFab";
import { ConfigurationTabItem, ConfigurationTabs } from "./ConfigurationTabs";
import { ConfigurationTree } from "./ConfigurationTree";
import { ConfigurationTypeCode } from "./ConfigurationTypeCode";
import { Individual } from "./Individual";
import { IndividualContainer } from "./IndividualContainer";
import { SubconfigurationNavigation } from "./SubconfigurationNavigation";
export const ConfigurationComponents = {
    [ConfigurationComponentType.Configuration]: ConfigurationContainer,
    [ConfigurationComponentType.ConfigurationBox]: BoxContainer,
    [ConfigurationComponentType.GridItem]: GridFragment,
    [ConfigurationComponentType.ConfigurationBackdrop]: ConfigurationBackdrop,
    [ConfigurationComponentType.ConfigurationHeadline]: ConfigurationHeadline,
    [ConfigurationComponentType.ConfigurationDescription]: ConfigurationDescription,
    [ConfigurationComponentType.ConfigurationPropertyText]: ConfigurationPropertyText,
    [ConfigurationComponentType.ConfigurationStatus]: ConfigurationStatusFab,
    [ConfigurationComponentType.ConfigurationTypeCode]: ConfigurationTypeCode,
    [ConfigurationComponentType.ConfigurationInfoText]: ConfigurationInfoText,
    [ConfigurationComponentType.AttributeContainer]: AttributeContainer,
    [ConfigurationComponentType.AttributeGroup]: AttributeGroup,
    [ConfigurationComponentType.ConfigurationTabs]: ConfigurationTabs,
    [ConfigurationComponentType.ConfigurationTabItem]: ConfigurationTabItem,
    [ConfigurationComponentType.ConfigurationNavigation]: ConfigurationNavigation,
    [ConfigurationComponentType.ConfigurationTree]: ConfigurationTree,
    [ConfigurationComponentType.ConfigurationDrawer]: ConfigurationTree,
    [ConfigurationComponentType.SubconfigurationNavigation]: SubconfigurationNavigation,
    [ConfigurationComponentType.IndividualContainer]: IndividualContainer,
    [ConfigurationComponentType.Individual]: Individual,
};
//# sourceMappingURL=ConfigurationComponents.js.map